// @ts-check
import React from 'react';

import { getAuthToken } from 'modules/auth/authSelectors';
import { useSelector } from 'react-redux';
import appConfigSelectors from 'modules/appConfig/selectors';
import useChatMiaw from './useChatMiaw';

/**
 * Gate component that initializes and manages the chat service across the application
 * @param {object} props
 * @param {React.ReactNode} props.children - The child elements to render
 * @returns {React.JSX.Element}
 */
const ChatMiawGate = ({ children }) => {
	const config = useSelector(appConfigSelectors.getAppConfig);
	const { chatConfig } = config || {};
	const authToken = useSelector(getAuthToken);

	const { ready } = useChatMiaw(chatConfig, {
		authToken,
		enabled: chatConfig?.enabled,
	});

	return (
		<>
			{children}
			{/* @ts-expect-error */}
			{ready && <chat-widget popups={false} color="#25A864" />}
		</>
	);
};

export default ChatMiawGate;
